import { render } from "./IncomesWidget.vue?vue&type=template&id=c25a0d0c"
import script from "./IncomesWidget.vue?vue&type=script&lang=js"
export * from "./IncomesWidget.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__